<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1.1" stepTitle="价格与套餐"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">价格设置</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="套餐名称" prop="optionName">
              <a-input v-model="ruleForm.optionName" :disabled="proSource!=0" :maxLength="20" style="max-width:700px;"
                       placeholder="请输入">
                <span slot="addonAfter">{{ ruleForm.optionName.length }}/20</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="同行价" required class="mb0">
              <a-form-model-item prop="priceMfAuditPrice" class="inline">
                <a-input addon-before="成人" v-model="ruleForm.priceMfAuditPrice" :disabled="proSource!=0"
                         placeholder="请输入成人同行价"/>
              </a-form-model-item>
              <a-form-model-item prop="priceMfAuditChildren" class="inline ml15">
                <a-input addon-before="儿童" v-model="ruleForm.priceMfAuditChildren" :disabled="proSource!=0"
                         placeholder="请输入儿童同行价"/>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item label="建议销售价" required class="mb0">
              <a-form-model-item prop="priceAdvicePrice" class="inline">
                <a-input addon-before="成人" v-model="ruleForm.priceAdvicePrice" :disabled="proSource!=0"
                         placeholder="请输入成人建议销售价"/>
              </a-form-model-item>
              <a-form-model-item prop="priceAdviceChildPrice" class="inline ml15">
                <a-input addon-before="儿童" v-model="ruleForm.priceAdviceChildPrice" :disabled="proSource!=0"
                         placeholder="请输入儿童建议销售价"/>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item v-if="proSource!=0" label="实际销售价" required class="mb0">
              <a-form-model-item prop="actualSalePrice" class="inline">
                <a-input addon-before="成人" v-model="ruleForm.actualSalePrice" :disabled="ruleForm.priceDistAdjust==1"
                         placeholder="请输入实际销售价"/>
              </a-form-model-item>
              <a-form-model-item prop="actualChildSalePrice" class="inline ml15">
                <a-input addon-before="儿童" v-model="ruleForm.actualChildSalePrice"
                         :disabled="ruleForm.priceDistAdjust==1" placeholder="请输入儿童实际销售价"/>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item v-if="proSource==0" label="采购价" required class="mb0">
              <a-form-model-item prop="pricePurchasePrice" class="inline">
                <a-input addon-before="成人" v-model="ruleForm.pricePurchasePrice" :disabled="proSource!=0"
                         placeholder="请输入成人采购价"/>
              </a-form-model-item>
              <a-form-model-item prop="pricePurchaseChildPrice" class="inline ml15">
                <a-input addon-before="儿童" v-model="ruleForm.pricePurchaseChildPrice" :disabled="proSource!=0"
                         placeholder="请输入儿童建议销售价"/>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item label="分销佣金" class="mb0">
              <a-form-model-item prop="commissionPrice" class="inline">
                <a-input addon-before="成人" v-model="ruleForm.commissionPrice" :disabled="proSource!=0"
                         placeholder="请输入成人分销佣金"/>
              </a-form-model-item>
              <a-form-model-item prop="commissionChildPrice" class="inline ml15">
                <a-input addon-before="儿童" v-model="ruleForm.commissionChildPrice" :disabled="proSource!=0"
                         placeholder="请输入儿童分销佣金"/>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item label="库存" prop="priceStock">
              <a-input v-model="ruleForm.priceStock" :disabled="proSource!=0" placeholder="请输入库存"/>
            </a-form-model-item>
            <a-form-model-item label="预警" prop="priceWarning">
              <a-input v-model="ruleForm.priceWarning" :disabled="proSource!=0" placeholder="请输入预警"/>
            </a-form-model-item>
            <a-form-model-item label="付款时间" prop="optionOrderPlayDate">
              <a-select v-model="ruleForm.optionOrderPlayDate" placeholder="请选择付款时间" style="max-width:300px;"
                        :disabled="proSource!=0">
                <a-select-option v-for="item in optionPaymentTimes" :key="item.value"
                                 :value="item.value">{{ item.label }}
                </a-select-option>
              </a-select>
              <span>钟内如未付款，系统将自动取消订单</span>
            </a-form-model-item>
            <a-form-model-item label="退款规则" prop="optionVisaRefundType" class="mb0">
              <a-radio-group v-model="ruleForm.optionVisaRefundType">
                <a-radio :value="0" style="line-height:40px;">拒签全额退款</a-radio>
                <a-radio :value="1" style="line-height:40px;">
                  <span>拒签退</span>
                  <a-form-model-item prop="optionVisaRefundValue" style="display:inline-block;">
                    <a-input v-model="ruleForm.optionVisaRefundValue" :disabled="proSource!=0" suffix="%"
                             placeholder="请输入退款率"/>
                  </a-form-model-item>
                </a-radio>
                <a-radio :value="2" style="line-height:40px;">拒签不退款</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="分销价格调整权限">
              <a-select v-model="ruleForm.priceDistAdjust" :disabled="proSource!=0" placeholder="请选择"
                        style="max-width:700px;">
                <a-select-option :value="1">不可调整</a-select-option>
                <a-select-option :value="2">不可低于建议销售价</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="是否需要二次确认">
              <a-select v-model="ruleForm.priceIsConfirm" :disabled="proSource!=0" placeholder="请选择"
                        style="max-width:700px;">
                <a-select-option :value="0">不需要</a-select-option>
                <a-select-option :value="1">需要</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="merchantLoginType==0" @click="onSubmit" :loading="submitLoading">
                提交
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import PublishPro from '../components/PublishPro'
import moment from 'moment'

export default {
  name: 'VisaProPrice',
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro
  },
  mixins: [ruleFormMixins],
  data() {
    var checkAdvicePrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.priceMfAuditPrice)) {
          callback(new Error('成人建议销售价必须要大于成人同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkAdviceChildPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.priceMfAuditChildren)) {
          callback(new Error('儿童建议销售价必须要大于儿童同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkCommissionPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (this.proSource == 0) {
          if (Math.round(Math.round(Number(this.ruleForm.priceAdvicePrice) * 100) - Math.round(Number(this.ruleForm.priceMfAuditPrice) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
            callback(new Error('必须小于成人建议销售价减成人同行价'))
          } else {
            callback()
          }
        } else {
          if (Math.round(Math.round(Number(this.ruleForm.actualSalePrice) * 100) - Math.round(Number(this.ruleForm.priceMfAuditPrice) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
            callback(new Error('必须小于成人实际销售价减成人同行价'))
          } else {
            callback()
          }
        }

      }, 1000)
    }
    var checkCommissionChildPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (this.proSource == 0) {
          if (Math.round(Math.round(Number(this.ruleForm.priceAdviceChildPrice) * 100) - Math.round(Number(this.ruleForm.priceMfAuditChildren) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
            callback(new Error('必须小于儿童建议销售价减儿童同行价'))
          } else {
            callback()
          }
        } else {
          if (Math.round(Math.round(Number(this.ruleForm.actualChildSalePrice) * 100) - Math.round(Number(this.ruleForm.priceMfAuditChildren) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
            callback(new Error('必须小于儿童实际销售价减儿童同行价'))
          } else {
            callback()
          }
        }

      }, 1000)
    }
    var checkWarning = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(this.ruleForm.priceStock) < Number(value)) {
          callback(new Error('预警值不能大于库存'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      moment,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      merchantLoginType: this.$store.getters.userInfo.merchantLoginType,
      merchantId: this.$store.getters.userInfo.merchantId,
      optionId: this.$route.query.optionId,
      ruleForm: {
        actualChildSalePrice: '',//实际销售价-儿童
        actualSalePrice: '',//实际销售价-成人
        commissionChildPrice: '',//分销佣金-儿童
        commissionPrice: '',//分销佣金-成人
        priceDistAdjust: 1,//分销价格调整权限 0 自有调整 1 不可调整 2 不可低于建议销售价 ,
        optionId: this.$route.query.optionId,// 签证套餐ID ,
        optionName: '',// 套餐名称 ,
        optionOrderPlayDate: 30,//付款时间
        optionVisaRefundType: 0,//退款规则 0全额退款 1部分退款 2不退款 ,
        optionVisaRefundValue: '',//退款 百分比
        priceAdviceChildPrice: '',//建议销售价-儿童
        priceAdvicePrice: '',//建议销售价-成人
        priceIsConfirm: 1,//是否需要二次确认 0 无需再次确认 1 需要再次确认
        priceMfAuditChildren: '',//同行价-儿童
        priceMfAuditPrice: '',//同行价-成人
        pricePurchaseChildPrice: '',//采购价-儿童
        pricePurchasePrice: '',//采购价-成人
        priceStock: '',//库存 ,
        priceWarning: '',//预警值
        proId: this.$route.query.proId,// 产品ID
        shopProSource: this.$route.query.proSource//是否自有产品 0是 1 平台直采 2 云仓分销
      },
      bedTypeList: [],
      hotelBindBeds: [],
      submitLoading: false,
      submitFormData: '',
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      optionPaymentTimes: [{
        value: 30,
        label: '30分'
      }, {
        value: 45,
        label: '45分'
      }, {
        value: 60,
        label: '60分'
      }],
      rules: {
        optionName: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' }
        ],
        priceMfAuditPrice: [
          { required: true, message: '请输入成人同行价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额(可带两位小数)',
            trigger: 'blur'
          }
        ],
        priceAdvicePrice: [
          { required: true, message: '请输入成人建议销售价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额(可带两位小数)',
            trigger: 'blur'
          },
          { validator: checkAdvicePrice, trigger: 'blur' }
        ],
        pricePurchasePrice: [
          { required: true, message: '请输入成人采购价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额(可带两位小数)',
            trigger: 'blur'
          }
        ],
        // 因为佣金和儿童可以输入0，所以采用新的正则
        commissionPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的成人分销佣金！', trigger: 'blur' },
          { validator: checkCommissionPrice, trigger: 'blur' }
        ],
        commissionChildPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的儿童分销佣金！', trigger: 'blur' },
          { validator: checkCommissionChildPrice, trigger: 'blur' }
        ],
        priceAdviceChildPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的儿童建议销售价！', trigger: 'blur' },
          { validator: checkAdviceChildPrice, trigger: 'blur' }
        ],
        priceMfAuditChildren: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的儿童同行价！', trigger: 'blur' }
        ],
        pricePurchaseChildPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的儿童采购价！', trigger: 'blur' }
        ],
        actualChildSalePrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的儿童实际销售价！', trigger: 'blur' }
        ],
        priceStock: [
          { pattern: /^[0-9]\d{0,5}$/, message: '请输入正确的库存', trigger: 'blur' }
        ],
        priceWarning: [
          { pattern: /^[0-9]\d{0,3}$/, message: '请输入正确的预警', trigger: 'blur' },
          { validator: checkWarning, trigger: 'blur' }
        ],
        optionVisaRefundValue: [
          { pattern: /^([1-9]\d?(\.\d{1,3})?|0\.\d{1,3}|100)$/, message: '请输入正确的比例', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getProPriceInfo()
  },
  methods: {
    checkForm() {
      if (this.ruleForm.optionVisaRefundType == 1) {
        if (!this.ruleForm.optionVisaRefundValue) {
          this.$message.error('请输入拒签退款比例')
          return false
        }
      }
      if (this.proSource == 1) {
        if (this.ruleForm.priceDistAdjust == 2) {
          if (Number(this.ruleForm.actualSalePrice) < Number(this.ruleForm.priceAdvicePrice)) {
            this.$message.error('成人实际销售价不能小于成人建议销售价')
            return false
          }
          if (Number(this.ruleForm.actualChildSalePrice) < Number(this.ruleForm.priceAdviceChildPrice)) {
            this.$message.error('儿童实际销售价不能小于儿童建议销售价')
            return false
          }
        }
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.getHttpServices().getProService().post('product/option/saveOrUpdateVisaOption', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('价格设置成功')
        setTimeout(() => {
          this.$router.push({
            name: 'OptionList',
            query: {
              proId: this.proId,
              catalogId: this.catalogId,
              proSource: this.proSource
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getProPriceInfo() {
      if (this.optionId != 0) {
        this.getHttpServices().getProService().post('product/option/getVisaOptionDes', {
          optionId: this.optionId,
          shopProSource: this.proSource,
          merchantId: this.merchantId
        }).then(res => {
          this.getLogUtils().logWithTag('getProPriceInfo', res)
          this.ruleForm = res
          this.ruleForm.optionVisaRefundValue = res.optionVisaRefundValue ? res.optionVisaRefundValue : ''
          this.ruleForm.priceDistAdjust = res.priceDistAdjust ? res.priceDistAdjust : 1

        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }

    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;

      .inline {
        display: inline-block;

        input {
          min-width: 260px;
        }
      }

      .ml15 {
        margin-left: 15px;
      }

      .mb0 {
        margin-bottom: 0;
      }
    }

    input {
      max-width: 700px;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>